import { SegmentedControl, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBot } from '@mygpt/app';

import { ConsentContentEditor } from '@/components/Common/ConsentContentEditor';

import type { ConsentType } from '@mygpt/app/consent';

/**
 * 设置 → 利用规约:chat(聊天分享页)与 realtime(实时对话)的自定义规约统一在此编辑。
 * - 开关不在此处:chat 开关在「分享」弹层(与「要求使用者输入昵称」并列),
 *   realtime 开关在「实时对话」设置的访问控制里
 * - 场景切换用 SegmentedControl,与外层设置 Tabs 区分,避免两层同款 tab 混淆
 * - 内容以 Markdown 存取(富文本编辑器所见即所得),未设置时前台回退内置模版
 */
export const Consent = () => {
  const { t } = useTranslation();
  const { botId } = useBot();
  const [scene, setScene] = useState<ConsentType>('chat');

  if (!botId) return null;

  return (
    <Stack gap="md" pr="md" pb={40}>
      <Text size="sm" c="gray.6">
        {t('consent.settings.desc')}
      </Text>
      <SegmentedControl
        w="fit-content"
        value={scene}
        onChange={(value) => setScene(value as ConsentType)}
        data={[
          { value: 'chat', label: t('consent.settings.tab_chat') },
          { value: 'realtime', label: t('consent.settings.tab_realtime') },
        ]}
      />
      {/* key 触发按场景重挂载,各自独立加载对应内容 */}
      <ConsentContentEditor key={scene} botId={botId} consentType={scene} />
    </Stack>
  );
};
